import * as Customer from '@/services/rest-api/lib/customer/customer'
import * as Branch from '@/services/rest-api/lib/branch/branch'

function getNowDate() {
  const now = new Date()
  const nowDate = new Date(now.toDateString())

  return nowDate
}

function buildStartDate(dateDiff = 0) {
  const startDate = getNowDate()
  if (dateDiff === -1) {
    startDate.setDate(1)
  } else if (dateDiff === -2) {
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * startDate.getDate())
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * (startDate.getDate() - 1))
  } else {
    startDate.setDate(startDate.getDate() - dateDiff)
  }
  return startDate
}

function buildEndDate(dateDiff = 0) {
  const endDate = getNowDate()
  if (dateDiff === -2) {
      endDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * endDate.getDate())
  } else {
    endDate.setDate(endDate.getDate() - dateDiff)
  }
  endDate.setHours(23, 59, 59, 999)

  return endDate
}

export const tableFilterFields = {
  computed: {
    tableFilterFields() {
      return [
        {
          name: 'external_date',
          isShow: true,
          label: this.$t("delivery.fields.createdDateDO"),
          type: 'date-picker',
          datepickerType: 'date',
          valueType: 'YYYY-MM-DD',
          format: 'DD MMM YYYY',
          titleFormat: 'DD MMM YYYY',
          rangeSeparator: ' - ',
          range: true,
          draft: true,
          confirm: true,
          confirmText: 'Terapkan',
          disabledDate: (date) => {
            return date > new Date()
          },
          shortcuts: [
            {
              text: this.$t("global.time.today"),
              onClick: () => {
                return [buildStartDate(), buildEndDate()]
              },
            },
            {
              text: this.$t("global.time.yesterday"),
              onClick: () => {
                return [buildStartDate(1), buildEndDate(1)]
              },
            },
            {
              text: this.$t("global.time.last3Days"),
              onClick: () => {
                return [buildStartDate(3), buildEndDate()]
              },
            },
            {
              text: this.$t("global.time.last7Days"),
              onClick: () => {
                return [buildStartDate(7), buildEndDate()]
              },
            },
            {
              text: this.$t("global.time.last30Days"),
              onClick: () => {
                return [buildStartDate(30), buildEndDate()]
              },
            },
            {
              text: this.$t("global.time.thisMonth"),
              onClick: () => {
                return [buildStartDate(-1), buildEndDate()]
              },
            },
            {
              text: this.$t("global.time.lastMonth"),
              onClick: () => {
                return [buildStartDate(-2), buildEndDate(-2)]
              },
            },
          ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick })),
        },
        {
          name: 'external_customer_id',
          isShow: true,
          label: this.$t("global.field.customer"),
          type: 'value-help-v2',
          placeholder: `${this.$t("global.form.select")} ${this.$t("global.field.customer")}`,
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: Customer.getExternal,
          multiple: true,
          tableFields: [
            {
              label: this.$t("global.field.name"),
              key: 'name',
              isSortable: true,
            },
            {
              label: "ID",
              key: 'number',
              isSortable: true,
            },
            {
              label: this.$t("global.field.address"),
              key: 'address',
            },
          ],
        },
        {
          name: 'branch_id',
          isShow: true,
          label: this.$t("global.field.branch"),
          type: 'value-help-v2',
          placeholder: `${this.$t("global.form.select")} ${this.$t("global.field.branch")}`,
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: Branch.getExternal,
          multiple: true,
          tableFields: [
            {
              label: this.$t("global.field.name"),
              key: 'name',
              isSortable: true,
            },
          ],
        },
        {
          name: 'integrated',
          isShow: true,
          label: this.$t('delivery.fields.hasCreatedInMEP'),
          type: 'radio-button',
          default: 'ShowAll',
          options: [
            {
              key: 'Yes',
              label: this.$t('delivery.integratedOptions.yes')
            },
            {
              key: 'No',
              label: this.$t('delivery.integratedOptions.no')
            },
            {
              key: 'ShowAll',
              label: this.$t('delivery.integratedOptions.showAll')
            }
          ]
        }
      ]
    }
  }
}
